module.exports = __webpack_public_path__ + "static/media/successful_sl.507ce2f3.png";